import styled from "styled-components";

export const TextDangerStyled = styled.p`
  color: #E6E134;
  font-size: 11px;
  margin: auto;
  padding: 0.25em;
  text-align: right;
`;